import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30a94fc6")

_pushScopeId("data-v-30a94fc6")
const _hoisted_1 = /*#__PURE__*/_createVNode("p", null, " Bereken in vijf stappen uw inkomen bij arbeidsongeschiktheid ", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Bereken uw inkomen ")
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "chip" }, " Let op deze berekening is een indicatie van uw inkomen ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")
  const _component_Step = _resolveComponent("Step")
  const _component_TestimonialPopupList = _resolveComponent("TestimonialPopupList")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Step, {
      navigation: false,
      step: _ctx.step,
      title: "Wat betekent arbeids­ongeschiktheid voor mijn situatie?"
    }, {
      default: _withId(() => [
        _hoisted_1,
        _createVNode("p", null, [
          _createVNode(_component_Button, {
            "icon-right": "chevron-right",
            onClick: _ctx.nextStep
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _hoisted_3
      ]),
      _: 1
    }, 8, ["step"]),
    (_ctx.isVisible)
      ? (_openBlock(), _createBlock(_component_TestimonialPopupList, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
})